let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4aZO2")).then(() => parcelRequire('el6Nx'));